import { ElementType, GlobalConfig } from "../types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

const createHeaderContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    padding: "15px 30px",
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  responsiveStyles: {
    tablet: {
      padding: "15px 10px",
    },
    mobile: {
      padding: "15px 10px",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        maxWidth: "1270px",
        margin: "0 auto",
      },
      children: [
        {
          id: generateId(),
          type: "logo" as ElementType,
          styles: {
            backgroundColor: "background",
            padding: "0 0 0 0",
            display: "flex",
            justifyContent: "space-between",
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "FORTI",
              styles: {
                fontSize: "32px",
                fontWeight: "bold",
                color: "forground",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "GOLD",
              styles: {
                fontSize: "32px",
                fontWeight: "normal",
                color: "forground",
                margin: "0",
              },
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            padding: "0 0 0 0",
            display: "flex",
            alignItems: "center",
            gap: "64px",
          },
          responsiveStyles: {
            tablet: {
              display: "none",
            },
            mobile: {
              display: "none",
            },
          },
          children: [
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "About",
              styles: {
                backgroudColor: "#ffffff00",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "600",
                color: "forground",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Benefits",
              styles: {
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "600",
                color: "forground",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "FAQ",
              styles: {
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "600",
                color: "forground",
              },
            },
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "ORDER NOW",
              styles: {
                backgroundColor: "#FBBC04",
                color: "forground",
                padding: "16px 24px",
                borderRadius: "16px",
                fontWeight: "600",
                fontStyle: "normal",
                fontSize: "20px",
                cursor: "pointer",
              },
            },
          ],
        },
        //Hamburger Button
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "none", // Hidden on desktop
            width: "44px",
            height: "44px",
            borderRadius: "50%",
            border: "none",
            alignItems: "center",
            justifyContent: "center",
            padding: "0",
            cursor: "pointer",
            marginLeft: "12px",
          },
          responsiveStyles: {
            tablet: {
              display: "flex",
            },
            mobile: {
              display: "flex",
            },
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/hamburger.svg",
              alt: "avatar1",
              styles: {
                width: "20px",
                height: "20px",
                objectContain: "contain",
                display: "block",
              },
            },
          ],
        },
      ],
    },
  ],
});

const createInfoHeaderSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    padding: "93px 10px",
    backgroundColor: "#F7F7F7",
    color: "forground",
    backdropFilter: "blur(14.3px)",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: { padding: "60px 10px" },
    mobile: { padding: "16px 10px" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1382px",
        width: "100%",
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
          },
          responsiveStyles: {
            tablet: {
              flexDirection: "column",
              gap: "10px",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            },
            mobile: {
              flexDirection: "column",
              gap: "10px",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            },
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Returns & Refunds Policy",
              styles: {
                fontFamily: "Manrope, sans-serif",
                fontSize: "70px",
                fontStyle: "normal",
                fontWeight: 800,
                lineHeight: "80px",
                letterSpacing: "-2.1px",
                textAlign: "left",
                margin: 0,
                color: "forground",
              },
              responsiveStyles: {
                desktop: { fontSize: "60px", lineHeight: "60px" },
                tablet: { fontSize: "50px", lineHeight: "50px" },
                mobile: {
                  fontSize: "45px",
                  lineHeight: "45px",
                  fontWeight: 700,
                },
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Date Effective: April 13, 2025",
              styles: {
                fontFamily: "Manrope, sans-serif",
                fontSize: "40px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "80px",
                letterSpacing: "-1.2px",
                textAlign: "left",
                margin: 0,
                color: "forground",
              },
              responsiveStyles: {
                desktop: { fontSize: "34px", lineHeight: "34px" },
                tablet: { fontSize: "34px", lineHeight: "34px" },
                mobile: { fontSize: "25px", lineHeight: "25px" },
              },
            },
          ],
        },
      ],
    },
  ],
});

type HeadingSize = "large" | "small";

const returnsRefundsSections: {
  heading: string;
  headingSize: HeadingSize;
  contents: string[];
}[] = [
  {
    heading: "Returns & Refunds Policy",
    headingSize: "large",
    contents: [
      "At FortiGold, your satisfaction is our priority. We stand behind the quality of our products and want you to feel confident in trying them. If for any reason you're not fully satisfied with your purchase, we offer a simple and straightforward refund process. This policy explains how you can return your product and request a refund, as well as what to expect along the way.",
      "We believe in giving our customers time to try our product and determine if it's the right fit for them. That's why we offer a 60-day money-back guarantee from the date of your original purchase. Whether the product is unopened, opened, or even used, you may request a refund within that time frame by following the steps outlined below.",
    ],
  },
  {
    heading: "Eligibility for Refunds",
    headingSize: "small",
    contents: [
      "To qualify for a refund, the product must have been purchased directly from FortiGold.com. If your order was placed through a third-party retailer, this policy does not apply, and you will need to contact the original seller. Additionally, your refund request must be submitted within 60 days of your order date. Requests made after this period may not be eligible.",
      "Products that have been damaged due to misuse, negligence, or improper storage are not eligible for refunds. Refunds are limited to one return per customer per product. Repeat refund requests from the same customer may be denied at our discretion.",
    ],
  },
  {
    heading: "How to Request a Refund",
    headingSize: "small",
    contents: [
      "To initiate a return, please begin by contacting our refund department. We ask that all refund requests be submitted via email so we can properly track and process them. This also ensures that we can provide you with the most up-to-date return instructions and the correct return address.",
      'Send an email to <a href="mailto:refund@fortigold.com"><b>refund@fortigold.com</b></a> with the subject line "Refund Request – [Your Order Number]." In the body of the email, please include your full name, the email address used when placing the order, your order number (if available), and a brief description of why you are requesting a refund. While providing a reason is optional, it helps us improve our products and service.',
      "Our team will respond to your request within one to two business days with a return authorization and mailing instructions. Please wait for confirmation before sending anything back to us.",
    ],
  },
  {
    heading: "Return Instructions",
    headingSize: "small",
    contents: [
      "After you receive our response, you will be instructed to send the remaining product—whether sealed, opened, or even empty—back to our return center at the following address:",
    ],
  },
  {
    heading: "SAMPLE RETURNS DEPT",
    headingSize: "small",
    contents: [
      "Fortigold<br>11870 62nd St. N Largo, FL 33773<br>+1 609 616 4468",
      "We strongly recommend that you use a trackable shipping service when returning your package. FortiGold is not responsible for items lost or damaged in transit. Return shipping costs are the responsibility of the customer and are not reimbursed.",
      "Please ensure that your return includes your original packing slip or a note with your full name, email, and order number so we can match it to your account. Returns without identifying information may be delayed or denied.",
    ],
  },
  {
    heading: "Processing Your Refund",
    headingSize: "small",
    contents: [
      "Once your returned product has been received and inspected at our facility, we will begin processing your refund. Refunds are issued to the original payment method used at checkout. Depending on your bank or credit card provider, it may take between five to seven business days for the refund to appear on your statement.",
      "We do not issue refunds for original shipping charges, if any were applied at checkout. In cases where a product was received damaged, please contact us immediately before initiating a return so we can evaluate whether a replacement or expedited resolution is more appropriate.",
    ],
  },
  {
    heading: "Additional Terms",
    headingSize: "small",
    contents: [
      "This policy is designed to be fair to our customers while preventing abuse. We reserve the right to deny refunds or limit returns if we identify patterns of excessive or fraudulent return activity. We may also require proof of purchase and documentation in rare cases of disputes or chargebacks.",
      "By purchasing from FortiGold.com, you agree to the terms of this Return & Refund Policy. This policy is subject to change at any time without notice. Updates will be posted to this page and the effective date will be revised accordingly.",
    ],
  },
  {
    heading: "Contact Us",
    headingSize: "small",
    contents: [
      'If you have any questions about this policy or need assistance with your return, our team is here to help. Please contact us directly at <a href="mailto:refund@fortigold.com"><b>refund@fortigold.com</b></a> and include as much information as possible so we can assist you quickly and efficiently.',
      "We appreciate your trust in FortiGold and thank you for giving our product a try.",
    ],
  },
];

const getHeadingStyles = (size: HeadingSize) =>
  size === "large"
    ? {
        color: "forground",
        fontFamily: "Poppins, sans-serif",
        fontSize: "55px",
        fontWeight: 700,
        lineHeight: "40px",
        letterSpacing: "-0.55px",
      }
    : {
        color: "forground",
        fontFamily: "Poppins, sans-serif",
        fontSize: "40px",
        fontWeight: 700,
        lineHeight: "40px",
        letterSpacing: "-0.4px",
      };

const getHeadingResponsive = (size: HeadingSize) =>
  size === "large"
    ? {
        desktop: { fontSize: "45px", lineHeight: "45px" },
        mobile: { fontSize: "40px", lineHeight: "40px" },
      }
    : {
        desktop: { fontSize: "34px", lineHeight: "34px" },
        mobile: { fontSize: "30px", lineHeight: "30px" },
      };

const returnsRefundsParagraphStyles = {
  color: "forground",
  fontFamily: "Poppins, sans-serif",
  fontSize: "28px",
  fontWeight: 400,
  lineHeight: "40px",
  letterSpacing: "-0.28px",
};

const returnsRefundsParagraphResponsive = {
  desktop: { fontSize: "24px", lineHeight: "36px" },
  mobile: { fontSize: "18px", lineHeight: "24px" },
};

const createPointersLinstingSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    padding: "120px 0",
    width: "100%",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: { padding: "80px 0", maxWidth: "95%", margin: "0 auto" },
    mobile: { padding: "40px 0", maxWidth: "95%", margin: "0 auto" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1339px",
        margin: "0 auto",
        width: "100%",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            gap: "60px 0",
            color: "forground",
          },
          responsiveStyles: {
            tablet: { gap: "40px 0" },
          },
          children: returnsRefundsSections.map((section) => ({
            id: generateId(),
            type: "container" as ElementType,
            styles: { display: "flex", flexDirection: "column", gap: "30px 0" },
            responsiveStyles: {
              tablet: { gap: "22px 0" },
              mobile: { gap: "18px 0" },
            },
            children: [
              {
                id: generateId(),
                type: "heading" as ElementType,
                content: section.heading,
                styles: getHeadingStyles(section.headingSize),
                responsiveStyles: getHeadingResponsive(section.headingSize),
              },
              {
                id: generateId(),
                type: "container" as ElementType,
                styles: {
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px 0",
                },
                responsiveStyles: {
                  desktop: { gap: "18px 0" },
                  mobile: { gap: "10px 0" },
                },
                children: section.contents.map((content) => ({
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content,
                  styles: returnsRefundsParagraphStyles,
                  typography: "Body",
                  responsiveStyles: returnsRefundsParagraphResponsive,
                })),
              },
            ],
          })),
        },
      ],
    },
  ],
});

const createScientificReferencesSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "100px 0 72px 0",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: { margin: "72px 0 36px 0" },
    mobile: { margin: "40px 0 32px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1334px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0px",
      },
      responsiveStyles: {
        tablet: { gap: "18px" },
        mobile: { gap: "12px" },
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Scientific References:",
          styles: {
            color: "forground",
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontSize: "34px",
            fontWeight: 400,
            lineHeight: "80px",
            letterSpacing: "-1.35px",
            margin: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          responsiveStyles: {
            mobile: { fontSize: "22px", lineHeight: "25px" },
          },
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "35px",
            height: "100px",
          },
          responsiveStyles: {
            tablet: { gap: "24px", height: "auto" },
            mobile: { gap: "20px", height: "auto" },
          },
          children: [
            ...[1, 2, 3, 4].map((i) => ({
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                maxWidth: "258px",
                width: "100%",
              },
              responsiveStyles: {
                tablet: { maxWidth: "220px" },
                mobile: { maxWidth: "167px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/scientificReferencesSection1.png",
                  alt: `Reference Logo ${i}`,
                  styles: {
                    width: "100%",
                    objectFit: "contain",
                  },
                },
              ],
            })),
          ],
        },
      ],
    },
  ],
});

const createScientificRefListingSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "60px 0 72px 0",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: { margin: "32px 0" },
    mobile: { margin: "24px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1334px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0px",
      },
      responsiveStyles: {
        tablet: { gap: "18px", maxWidth: "95%" },
        mobile: { gap: "12px", maxWidth: "95%" },
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "24px",
          },
          responsiveStyles: {
            tablet: { gap: "18px", flexDirection: "column" },
            mobile: { gap: "12px", flexDirection: "column" },
          },
          children: [
            // First Col
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "calc(50% - 12px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "16px",
              },
              responsiveStyles: {
                tablet: { width: "100%" },
                mobile: { width: "100%" },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
              ],
            },
            // Second Col
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "calc(50% - 12px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "16px",
              },
              responsiveStyles: {
                tablet: { width: "100%" },
                mobile: { width: "100%" },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createFooterMenuSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "primary",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "100%",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            height: "100px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "0 72px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: {
              gap: "0 24px",
            },
            mobile: {
              flexDirection: "column",
              gap: "28px 16px",
              height: "auto",
              padding: "28px 0",
            },
          },
          children: [
            // Privacy
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Privacy",
              href: "/privacy-policy",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Terms & Conditions
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Terms & Conditions",
              href: "/terms-and-conditions",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Disclaimer
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Disclaimer",
              href: "/disclaimer",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Product Label (trigger, not a link)
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "Product Label",
              // href: "#product-label",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
                cursor: "pointer",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
              triggerPopup: "fortigold-label-popup",
              // You can add a custom property for JS trigger if needed
            },
            // Returns & Refunds
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Returns & Refunds",
              href: "/returns-and-refunds",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Contact
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Contact",
              href: "/contact-us",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

const createFooterEndSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "background",
    margin: 0,
    padding: 0,
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "12px",
        padding: "60px 0 0",
      },
      responsiveStyles: {
        mobile: {
          padding: "0 15px",
          margin: "30px auto 0",
        },
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. The information presented on this site is for informational purposes only and is not a substitute for advice from your physician or other healthcare professional. Always consult with a qualified healthcare provider before beginning any diet, supplement, or exercise program.",
          styles: {
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.60)",
            fontFamily: "Poppins, sans-serif",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "28px",
            letterSpacing: "-0.28px",
          },
          responsiveStyles: {
            mobile: {
              fontSize: "16px",
            },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Individual results may vary. Testimonials and reviews appearing on this site reflect real-life experiences of individuals who used our products. However, results may not be typical and are not guaranteed.",
          styles: {
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.60)",
            fontFamily: "Poppins, sans-serif",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "28px",
            letterSpacing: "-0.28px",
          },
          responsiveStyles: {
            mobile: {
              fontSize: "16px",
            },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Copyright © 2024 – 2025 FortiGold. All Rights Reserved.",
          styles: {
            padding: "30px 0",
            color: "rgba(0, 0, 0, 0.60)",
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontSize: "22px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "45px",
            letterSpacing: "-0.22px",
          },
          responsiveStyles: {
            tablet: {
              padding: "10px 0",
              fontSize: "12px",
            },
            mobile: {
              padding: "10px 0",
              fontSize: "12px",
            },
          },
        },
      ],
    },
  ],
});

export const template1Refund = (globalConfig: GlobalConfig) => {
  return {
    header: createHeaderContainer(globalConfig),
    infoHeaderSection: createInfoHeaderSection(globalConfig),
    pointersListingsSection: createPointersLinstingSection(globalConfig),
    scientificReferencesSection:
      createScientificReferencesSection(globalConfig),
    scientificRefListingSection:
      createScientificRefListingSection(globalConfig),
    footerMenuSection: createFooterMenuSection(globalConfig),
    footerEndSection: createFooterEndSection(globalConfig),
  };
};
